import type { ProfileUnlockTarget } from '@/hooks/actions/use-unlock-creator-profile-action';
import { useProfileUnlockQuota } from '@/hooks/queries/use-profile-unlock-quota';
import type { CreatorProfileUnlockOutcome } from '@fluenceur/types';
import type { ReactNode } from 'react';
import ContactUnlockButton from './ContactUnlockButton';

/**
 * The unlock button in place of the email button, on a plan that counts
 * profile unlocks. Any other plan (or features still loading) keeps the
 * `fallback`, the email button the plan locks.
 */
export const ContactUnlockSlot = ({
  target,
  fallback,
  onUnlocked,
}: {
  target: ProfileUnlockTarget;
  fallback: ReactNode;
  onUnlocked: (outcome: CreatorProfileUnlockOutcome) => void;
}) => {
  const quota = useProfileUnlockQuota();
  if (!quota || quota.limit === null) return <>{fallback}</>;

  return (
    <ContactUnlockButton
      target={target}
      quota={{ ...quota, limit: quota.limit }}
      onUnlocked={onUnlocked}
    />
  );
};
